import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";

interface UseDeletePrivateCompanyLeadContactProps {
  contactId?: string
  onSuccess: () => void
  onError: () => void
}

const useDeletePrivateCompanyLeadContact = ({ contactId, onSuccess, onError }: UseDeletePrivateCompanyLeadContactProps) => {
  const privateAxios = usePrivateAxios();
  return useMutation({
    mutationKey: ['deletePrivateCompanyLeadContact'],
    mutationFn: async () => {
      await privateAxios.delete(`/funnel/contacts/${contactId}`)
    },
    onSuccess,
    onError,
  });
}

export default useDeletePrivateCompanyLeadContact